import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import userServices from 'services/httpService/userAuth/userServices';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import ErrorService from 'services/formatError/ErrorService';
import { toast } from 'react-toastify';
import { serviceCharges, endPoint } from 'config/config';
import CircularProgress from '@mui/material/CircularProgress';
import PhoneInput from 'react-phone-input-2';

function CheckBalance() {
  const [phNo, setphNo] = useState('');

  const [blance, setblance] = useState('');
  const checkBlance = useMutation(
    (checkBlanceCustomer) =>
      userServices.commonPostService('/checkBlance', checkBlanceCustomer),
    {
      onError: (error) => {
        //// seterrorMsg(ErrorService.uniformError(error));

        toast.error(ErrorService.uniformError(error));
      },
      onSuccess: (result) => {
        // console.log('1st pay', result);
        let res = result.data.data.blance;
        setblance(res.$numberDecimal);
      },
    }
  );

  return (
    <div className=''>
      <div className='my-2 mb-4'>What number will you like to check </div>

      <PhoneInput
        country={'us'}
        name='phoneNumber'
        id='phoneNumber'
        type='number'
        containerClass=' placeholder-white text-white bg-color-grey  text-sm shadow '
        inputClass='phone-styl focus:outline-none   focus:ring rounded w-full ease-linear transition-all duration-150'
        searchClass='searchClass text-black'
        dropdownClass='bg-black dropdown-styl'
        enableSearch
        placeholder='Phone Number'
        // onChange={formik.handleChange}
        onChange={(phone) => setphNo(phone)}
        // onBlur={formik.handleBlur}
        // value={formik.values.phoneNumber}
      />

      {/* 
      <TextField
        label='Phone Number'
        variant='filled'
        onChange={(e) => setphNo(e.target.value)}
        id='sms'
        // type='number'
        required
        // onChange={(e) => settotalAmount(e.target.value * serviceCharges)}
        style={{
          color: 'white',
          backgroundColor: '#282828',
        }}
        fullWidth
        InputLabelProps={{
          style: { color: '#999999' },
        }}
        InputProps={{
          disableUnderline: true,
        }}
        sx={{ input: { color: 'white' } }}

        ////value={localStorageData('contactNo')}
        //// disabled
      /> */}

      <div className='my-6'>
        <button
          onClick={() => {
            if (phNo) {
              checkBlance.mutate({ phNo: '+' + phNo });
            }
          }}
          className='btn-styl '
        >
          Check balance
        </button>

        {blance != '' ? <>Your credit is {blance}</> : null}
      </div>
      <div className='text-white'>You have credits left</div>
    </div>
  );
}

export default CheckBalance;
